import { IconBaseProps } from 'react-icons';
import { AiFillWarning } from 'react-icons/ai';
import {
  BsBug,
  BsDashCircle,
  BsEnvelope,
  BsEnvelopeFill,
  BsEnvelopeOpen,
  BsGrid3X3Gap,
  BsPlusCircle,
} from 'react-icons/bs';
import * as FI from 'react-icons/fi';
import { RiEyeCloseLine, RiEyeLine } from 'react-icons/ri';

import { UserClock } from 'assets/icons';

const allIcons = {
  ...FI,
  RiEyeCloseLine,
  RiEyeLine,
  AiFillWarning,
  BsGrid3X3Gap,
  BsEnvelope,
  BsEnvelopeOpen,
  UserClock,
  BsEnvelopeFill,
  BsPlusCircle,
  BsDashCircle,
  BsBug,
};

export type IconName = keyof typeof allIcons;

type IconProps = {
  name: IconName;
  className?: string;
} & IconBaseProps;

export function Icon(props: IconProps): React.ReactElement {
  const { name, className, ...rest } = { ...props };

  const Tag = allIcons[name];

  return className ? (
    <span className={className}>
      <Tag {...rest} />
    </span>
  ) : (
    <Tag {...rest} />
  );
}
